"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var react_2 = require("@emotion/react");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_2 = require("@ryerson/frontend.assets");

var frontend_button_1 = require("@ryerson/frontend.button");

var StaticItem_1 = __importDefault(require("../../common/StaticItem"));

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var frontend_application_1 = require("@ryerson/frontend.application"); //import { SearchInput } from "@ryerson/frontend.form-controls";


var util_1 = require("../../common/util");

var PhoneLinkRenderer_1 = require("../../Renderers/PhoneLinkRenderer");

var HeaderConfig_1 = require("../../common/HeaderConfig/HeaderConfig");

var withTranslation = {
  metal: {
    en: "Metal",
    es: "Metal",
    fr: "Métal"
  },
  search: {
    en: "Search",
    es: "Rechercher",
    fr: "Buscar"
  },
  metalFinder: {
    en: "Metal Finder",
    es: "Recherche de métaux",
    fr: "Buscador de metales"
  },
  creditApplication: {
    en: "Credit Application",
    es: "Solicitud de crédito",
    fr: "Demande de crédit"
  }
};

var MobileFooter = function MobileFooter(_ref) {
  var companyName = _ref.companyName,
      footerData = _ref.footerData,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      _ref3$localization = _ref3.localization,
      language = _ref3$localization.language,
      country = _ref3$localization.country;

  var _ref4 = (0, react_1.useState)(withTranslation.metalFinder[language]),
      _ref5 = _slicedToArray(_ref4, 2),
      metalFinderText = _ref5[0],
      setMetalFinderText = _ref5[1]; //const [searchPlaceholderText, setSearchPlaceholderText] = useState<string>(
  //	withTranslation.search[language]
  //);


  var _ref6 = (0, react_1.useState)(withTranslation.metal[language]),
      _ref7 = _slicedToArray(_ref6, 2),
      metalText = _ref7[0],
      setMetalText = _ref7[1];

  var headerSettings = HeaderConfig_1.headerConfigData[companyName]; // Font Colors

  var white = theme.colors.primary.white;
  var lightGrey = theme.colors.primary.lightGray;
  var darkGrey = theme.colors.primary.darkGray;
  var grey = theme.colors.primary.gray;
  var secondary = theme.colors.primary.secondaryBrand;
  var primary = theme.colors.primary.primaryBrand; // Layout style

  var Footer = styled_1.default.footer(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tbackground-color: ", ";\n\t"])), secondary);
  var liveChat = (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tpadding-left: 25px;\n\t\tpadding-right: 25px;\n\t"])));
  var Hr = styled_1.default.hr(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tborder-top: 1px solid ", ";\n\t\topacity: 0.1;\n\t"])), white);
  var LogoContainer = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tpadding-top: 27px;\n\t\tpadding-bottom: 29px;\n\t"])));
  var headerPadding = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tpadding-top: 10px;\n\t\tpadding-bottom: 5px;\n\t"])));
  var socialMediaIcon = (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\tpadding-right: 20px;\n\t\t&:nth-of-type(4) {\n\t\t\tpadding-right: 0px;\n\t\t}\n\t"])));
  (0, react_1.useEffect)(function () {
    setMetalText(withTranslation.metal[language]);
    setMetalFinderText(withTranslation.metalFinder[language]); //setSearchPlaceholderText(withTranslation.search[language]);
  }, [language]);
  return (0, jsx_runtime_1.jsx)(Footer, {
    className: "footer-mobile",
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Container, {
      vPadding: "0",
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        style: headerPadding,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          grow: 1,
          children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country)
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: liveChat,
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            size: "md",
            itemName: "liveChat",
            color: white
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            label: "",
            onClick: function onClick() {
              if (window && window.LiveChatWidget) window.LiveChatWidget.call("maximize");
            },
            background: primary,
            size: "sm",
            foreground: "light",
            leftIcon: "comment",
            shape: "circle"
          })
        })]
      }), (0, jsx_runtime_1.jsx)(Hr, {}), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        style: (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\t"]))),
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-right: 20px;\n\t\t\t\t\t\t"]))),
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "contactUs",
            size: "md",
            color: lightGrey
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "locations",
            size: "md",
            color: lightGrey
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\t\t"]))),
          children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
            to: "".concat(storeDirectory, "/credit-application"),
            size: "md",
            gatsby: (0, util_1.isGatsbyLink)(true, storeDirectory),
            color: lightGrey,
            dataTestId: "link-click",
            children: withTranslation.creditApplication[language]
          })
        })]
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        direction: "column",
        justifyContent: "space-between",
        style: (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 40px;\n\t\t\t\t\t"]))),
        children: (0, jsx_runtime_1.jsxs)(frontend_expansion_1.Accordion, {
          multiple: true,
          type: "tertiary",
          children: [(0, jsx_runtime_1.jsxs)(frontend_expansion_1.AccordionTab, {
            header: metalText,
            type: "tertiary",
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              direction: "column",
              css: (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding: 20px 0;\n\t\t\t\t\t\t\t\t"]))),
              children: footerData === null || footerData === void 0 ? void 0 : footerData.column1Links.map(function (link, index) {
                return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "column",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    style: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                      disabled: link.url ? false : true,
                      to: (0, util_1.getUrl)(link.url),
                      gatsby: true,
                      size: "md",
                      color: link.url ? white : grey,
                      children: link.label
                    })
                  })
                }, "product-".concat(index));
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              direction: "column",
              css: (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding-bottom: 60px;\n\t\t\t\t\t\t\t\t"]))),
              children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                css: (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding: 20px 0;\n\t\t\t\t\t\t\t\t\t"]))),
                children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                    to: "/store/",
                    gatsby: false,
                    children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
                      label: metalFinderText,
                      background: darkGrey,
                      foreground: "light",
                      shape: "rounded",
                      onClick: function onClick() {},
                      size: "sm"
                    })
                  })
                }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  css: (0, react_2.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0 0 20px;\n\t\t\t\t\t\t\t\t\t\t"]))),
                  children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                    itemName: "getStocklist",
                    color: primary,
                    type: "tertiary"
                  })
                })]
              })
            })]
          }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
            header: footerData === null || footerData === void 0 ? void 0 : footerData.column2Title,
            type: "tertiary",
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              direction: "column",
              css: (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding: 20px 0;\n\t\t\t\t\t\t\t\t"]))),
              children: footerData === null || footerData === void 0 ? void 0 : footerData.column2Links.map(function (link, index) {
                return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "column",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    style: (0, react_2.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                      disabled: link.url ? false : true,
                      to: (0, util_1.getUrl)(link.url),
                      gatsby: true,
                      size: "md",
                      color: link.url ? white : grey,
                      children: link.label
                    })
                  })
                }, "product-".concat(index));
              })
            })
          }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
            header: footerData === null || footerData === void 0 ? void 0 : footerData.column3Title,
            type: "tertiary",
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              direction: "column",
              css: (0, react_2.css)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding: 20px 0;\n\t\t\t\t\t\t\t\t"]))),
              children: footerData === null || footerData === void 0 ? void 0 : footerData.column3Links.map(function (link, index) {
                return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "column",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    style: (0, react_2.css)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                      disabled: link.url ? false : true,
                      to: (0, util_1.getUrl)(link.url),
                      gatsby: true,
                      size: "md",
                      color: link.url ? white : grey,
                      children: link.label
                    })
                  })
                }, "product-".concat(index));
              })
            })
          }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.AccordionTab, {
            header: footerData === null || footerData === void 0 ? void 0 : footerData.column4Title,
            type: "tertiary",
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              direction: "column",
              css: (0, react_2.css)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tpadding: 20px 0;\n\t\t\t\t\t\t\t\t"]))),
              children: footerData === null || footerData === void 0 ? void 0 : footerData.column4Links.map(function (link, index) {
                return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  direction: "column",
                  justifyContent: "space-between",
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                    style: (0, react_2.css)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0;\n\t\t\t\t\t\t\t\t\t\t\t\t"]))),
                    children: link.label !== "SPACER" && (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                      disabled: link.url ? false : true,
                      to: (0, util_1.getUrl)(link.url),
                      gatsby: true,
                      size: "md",
                      color: link.url ? white : grey,
                      children: link.label
                    })
                  })
                }, "product-".concat(index));
              })
            })
          })]
        })
      }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "center",
        style: (0, react_2.css)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 20px;\n\t\t\t\t\t"]))),
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          grow: 1,
          children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
            itemName: "followUs",
            size: "md",
            returnType: "text",
            color: grey
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            alignItems: "center",
            style: (0, react_2.css)(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\theight: 50px;\n\t\t\t\t\t\t\t"]))),
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: socialMediaIcon,
              children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                to: "https://www.facebook.com/ryersonmetals/?fref=nf",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "social-facebook",
                  size: "sm",
                  color: white,
                  onClick: function onClick() {}
                })
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: socialMediaIcon,
              children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                to: "https://www.instagram.com/ryersonmetals/?hl=en",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "social-instagram",
                  size: "sm",
                  color: white,
                  onClick: function onClick() {}
                })
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: socialMediaIcon,
              children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                to: "https://www.linkedin.com/company/ryerson?trk=top_nav_home",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "social-linked-in",
                  size: "sm",
                  color: white,
                  onClick: function onClick() {}
                })
              })
            }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: socialMediaIcon,
              children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                to: "https://www.youtube.com/channel/UCAjLhGiGaSBbTOwq52rZNAw",
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "social-youtube",
                  size: "sm",
                  color: white,
                  onClick: function onClick() {}
                })
              })
            })]
          })
        })]
      }), (0, jsx_runtime_1.jsx)(Hr, {}), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        style: (0, react_2.css)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 15px;\n\t\t\t\t\t\tline-height: 20px;\n\t\t\t\t\t"]))),
        wrap: "wrap",
        children: [(0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "privacyPolicy",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          color: grey,
          css: (0, react_2.css)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t\t"]))),
          children: "\xA0\xA0/\xA0\xA0"
        }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "usStatePrivacyDisclosure",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          color: grey,
          css: (0, react_2.css)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t\t"]))),
          children: "\xA0\xA0/\xA0\xA0"
        }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "californiaTransparencySupplyChainAct",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          color: grey,
          css: (0, react_2.css)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t\t"]))),
          children: "\xA0\xA0/\xA0\xA0"
        }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "securityStatement",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          color: grey,
          css: (0, react_2.css)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t\t"]))),
          children: "\xA0\xA0/\xA0\xA0"
        }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "termsAndConditions",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "xs",
          color: grey,
          css: (0, react_2.css)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t\t"]))),
          children: "\xA0\xA0/\xA0\xA0"
        }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "transparencyInCoverage",
          type: "tertiary",
          color: lightGrey,
          size: "xs"
        })]
      }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        variant: "div",
        size: "xs",
        color: grey,
        css: (0, react_2.css)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 20px;\n\t\t\t\t\t"]))),
        children: [new Date().getFullYear(), " \xA9", " ", (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
          itemName: "allRightsReserved",
          returnType: "text",
          color: grey,
          size: "xs"
        }), " ", "Ryerson"]
      }), companyName === HeaderConfig_1.companyNameData.ryerson && (0, jsx_runtime_1.jsx)(LogoContainer, {
        children: (0, jsx_runtime_1.jsx)(frontend_assets_2.RyersonLogo, {
          color: "white",
          width: "100%"
        })
      }), companyName === HeaderConfig_1.companyNameData.southernToolSteel && (0, jsx_runtime_1.jsx)(frontend_assets_2.STSLogo, {
        color: "white",
        width: "100%"
      })]
    })
  });
};

exports.default = MobileFooter;